module.exports = __webpack_public_path__ + "media/C_1.195b42ca.mp3";